import React from "react"
import { ActionContainer, ListEditorItem, ListEditorMainContainer, ListItemContent } from "./styles"
import { ReactComponent as ExIcon } from 'common/images/icon-cross-dark.svg'

export interface ListEditorProps {
    onActionClick: (index: number, event: any) => void
}

export const ListEditor: React.FunctionComponent<ListEditorProps> = (props: React.PropsWithChildren<ListEditorProps>) => {
    return (
        <ListEditorMainContainer>
            {
                React.Children.map(props.children, (child, idx) => {
                    return (
                        <ListEditorItem>
                            <ListItemContent>
                                {
                                    child
                                }
                            </ListItemContent>
                            <ActionContainer>
                                <ExIcon
                                    title={"Remove"}
                                    onClick={(event) => props.onActionClick(idx, event)}
                                />
                            </ActionContainer>

                        </ListEditorItem>
                    )
                })
            }
        </ListEditorMainContainer>
    )
}